export const SCREEN_HEIGHT = 1080;
export const HEADER_HEIGHT = 60;
export const SCREEN_WIDTH = 1920;
export const LAYOUT_DEFAULT_GAP = 20;
export const SIDE_MENU_Layout = 100000;
